import { useOrdersColumnsPopoverController } from "./OrdersColumnsPopover.controller";
import { OrdersColumnsPopoverPresentation } from "./OrdersColumnsPopover.pres";
import type {
  OrdersWidgetColumnId,
  OrdersWidgetColumnOption,
} from "./OrdersWidget.columns";
import type {
  OrdersColumnMoveDirection,
  ReorderOrdersColumns,
} from "./useOrdersColumnVisibility";

export interface OrdersColumnsPopoverProps {
  columnOptions: readonly OrdersWidgetColumnOption[];
  visibleColumnIds: readonly OrdersWidgetColumnId[];
  requiredColumnIds: readonly OrdersWidgetColumnId[];
  onColumnVisibilityChange: (
    columnId: OrdersWidgetColumnId,
    isVisible: boolean,
  ) => void;
  onMoveColumn: (
    columnId: OrdersWidgetColumnId,
    direction: OrdersColumnMoveDirection,
  ) => void;
  onReorderColumns: ReorderOrdersColumns;
  onSelectAllColumns: () => void;
  onResetColumns: () => void;
}

export const OrdersColumnsPopover = ({
  columnOptions,
  visibleColumnIds,
  requiredColumnIds,
  onColumnVisibilityChange,
  onMoveColumn,
  onReorderColumns,
  onSelectAllColumns,
  onResetColumns,
}: OrdersColumnsPopoverProps) => {
  const drag = useOrdersColumnsPopoverController({ onReorderColumns });

  return (
    <OrdersColumnsPopoverPresentation
      columnOptions={columnOptions}
      visibleColumnIds={visibleColumnIds}
      requiredColumnIds={requiredColumnIds}
      onColumnVisibilityChange={onColumnVisibilityChange}
      onMoveColumn={onMoveColumn}
      onSelectAllColumns={onSelectAllColumns}
      onResetColumns={onResetColumns}
      {...drag}
    />
  );
};
